import {Button} from '@mui/material';
import {ArrowCircleUp,ArrowCircleDown} from '@mui/icons-material';

const ButtonShowMoreInfo=({showMoreInfo,handleShowMoreInfo,application})=>{
    return (
        <Button style={{marginBottom:'10px'}} startIcon={showMoreInfo?<ArrowCircleUp/>:<ArrowCircleDown/>} onClick={handleShowMoreInfo}>{showMoreInfo?application.getLocale("HideMoreInfo"):application.getLocale("ShowMoreInfo")}</Button>
    );
}

export default ButtonShowMoreInfo;
